<template>
  <v-list-item class="theme-mode-toggle">
    <template #prepend>
      <v-icon>mdi-theme-light-dark</v-icon>
    </template>
    <v-list-item-title>Theme</v-list-item-title>
    <template #append>
      <v-btn-toggle
        :model-value="preference"
        mandatory
        divided
        density="compact"
        variant="outlined"
        @update:model-value="changePreference"
      >
        <v-btn
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :aria-label="option.label"
          size="small"
        >
          <v-icon size="small" start>{{ option.icon }}</v-icon>
          {{ option.label }}
        </v-btn>
      </v-btn-toggle>
    </template>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import vuetify from '@/plugins/vuetify';
import { ThemePreferenceEnum } from '@/bundles/App/enums/ThemePreferenceEnum';
import { saveThemePreference } from '@/bundles/App/helpers/themePreference';

export default defineComponent({
  name: 'ThemeModeToggle',

  data: () => ({
    options: Object.freeze([
      { value: ThemePreferenceEnum.system, label: 'System', icon: 'mdi-laptop' },
      { value: ThemePreferenceEnum.light, label: 'Light', icon: 'mdi-white-balance-sunny' },
      { value: ThemePreferenceEnum.dark, label: 'Dark', icon: 'mdi-weather-night' },
    ]),
  }),

  computed: {
    // The app-wide theme, not `$vuetify.theme`: inside a `theme="darkChrome"` subtree
    // (the sidebar hosts this menu on smaller screens) that reports the local
    // theme. Vuetify resolves `system` to light/dark in `name`; `isSystem`
    // keeps the choice itself.
    preference (): ThemePreferenceEnum {
      const { theme } = vuetify;

      return theme.isSystem.value ? ThemePreferenceEnum.system : theme.name.value as ThemePreferenceEnum;
    },
  },

  methods: {
    changePreference (preference: ThemePreferenceEnum) {
      vuetify.theme.change(preference);
      saveThemePreference(preference);
    },
  },
});
</script>
